import { IExamMasterCodeItem, LookupListApiItem } from '../../api/user/model';
import { GET_IEXAM2_DETAILS_URL } from '../../constants/apiUrls';
import { GET_IEXAM2_DETAILS_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';

// =============================================================================
// Request & Response Model
// =============================================================================
export interface IExamContentResponse {
  race: IExamMasterCodeItem[];
  gender: IExamMasterCodeItem[];
  nationality: IExamMasterCodeItem[];
  countryCode: IExamMasterCodeItem[];
  citizenship: IExamMasterCodeItem[];
  prStatus: IExamMasterCodeItem[];
  salutation: LookupListApiItem[];
  designation: LookupListApiItem[];
  relationship: IExamMasterCodeItem[];
  occupation: LookupListApiItem[];
}

interface Input {
  enabled?: boolean;
}

// =============================================================================
// Query
// =============================================================================
export const useGetIExamMasterCode = ({ enabled = true }: Input = {}) => {
  const getIExamMasterCode = async () => {
    const res = await axiosClient.get<IExamContentResponse>(GET_IEXAM2_DETAILS_URL);

    return res.data;
  };

  return useCustomQuery(
    GET_IEXAM2_DETAILS_QUERY_KEY,
    getIExamMasterCode,
    {
      staleTime: Infinity,
      enabled,
    },
    false,
    false
  );
};
